module.exports = __webpack_public_path__ + "img/paypal-small.9e01fd9a.png";